<template>
  <div class="editable-page-model-h5-25" :style="{backgroundColor:editablePageConfig.editable_page_config_content.back_color,paddingTop:editablePageConfig.editable_page_config_content.margin_top,paddingBottom:editablePageConfig.editable_page_config_content.margin_bottom}">
    <div class="aboutus">
      <div class="aboutus_bt" v-if="editablePageConfig.editable_page_config_content.text[0].list[0]">
        <div class="h3">
          {{ editablePageConfig.editable_page_config_content.text[0].list[0].content }}
        </div>
      </div>
      <div class="aboutus_con">
        <div class="aboutus_con_video">
          <video
            v-bind:src="editablePageConfig.editable_page_config_content.video[0].list[0].path"
            controls
          >
          </video>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Model25',
  data () {
    return {
    }
  },
  props: ['editablePageConfig'],
  computed: {

  },
  methods: {

  }
}
</script>
<style scoped>
.editable-page-model-h5-25 .aboutus {
  padding: 0 15px 5px;
  margin-top: 0.6rem;
}
.editable-page-model-h5-25 .aboutus_bt .h3 {
  font-weight: 700;
  font-size: 16px;
  line-height: 1.25;
  color: #0F1111 !important;
}
.editable-page-model-h5-25 .aboutus_con {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-justify-content: flex-end;
  justify-content: flex-end;
  -webkit-align-items: center;
  align-items: center;
  margin-top: 0.6rem;
}
.editable-page-model-h5-25 .aboutus_con_video video {
  background: #000;
  display: block;
  height: 100%;
  width: 100%;
}
</style>
